import firebase from 'firebase/compat/app';

import AuthService from '@cardladder/shared/services/auth.service';
import CardsService from '@cardladder/shared/services/cards.service';
import FeedService from '@cardladder/shared/services/feed.service';
import ImageService from '@cardladder/shared/services/image.service';
import IndexService from '@cardladder/shared/services/index.service';
import NotificationService from '@cardladder/shared/services/notification.service';
import PlayersService from '@cardladder/shared/services/players.service';
import SalesService from '@cardladder/shared/services/sales.service';
import SearchService from '@cardladder/shared/services/search.service';

import { withSearchAuthRetry } from '@/utils/searchAuth.util';

export const authService = new AuthService(firebase);
export const cardService = new CardsService(firebase);
export const feedService = new FeedService(firebase);
export const imageService = new ImageService(firebase);
export const indexService = new IndexService(firebase);
export const notificationService = new NotificationService(firebase);
export const playerService = new PlayersService(firebase);
export const saleService = new SalesService(firebase);

const baseSearchService = new SearchService();

function wrapSearchMethod(method) {
  return (...args) => withSearchAuthRetry(() => method.apply(baseSearchService, args));
}

export const searchService = {
  search: wrapSearchMethod(baseSearchService.search.bind(baseSearchService)),
  getDoc: wrapSearchMethod(baseSearchService.getDoc.bind(baseSearchService)),
  searchSuggestions: wrapSearchMethod(baseSearchService.searchSuggestions.bind(baseSearchService)),
  searchImage: wrapSearchMethod(baseSearchService.searchImage.bind(baseSearchService)),
};
